module.exports = __webpack_public_path__ + "static/media/banner-participe.c66de8dd.png";